import SectionTitle from '@/components/base/SectionTitle';

export default function Tarifs() {
  return (
    <section id="tarifs" className="py-20 sm:py-28 lg:py-16 bg-[#fbf9f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          label="Nos Tarifs"
          title="Tarifs"
          delay={100}
        />
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-14 xl:gap-16 max-w-6xl mx-auto animate-fade-in-up delay-300">
          {/* Tarification */}
          <div className="rounded-lg border-2 border-[#00A8B5]/30 relative overflow-hidden p-8 lg:p-10 bg-white/70 transition-all duration-[250ms] ease-out hover:-translate-y-1 hover:shadow-lg hover:scale-[1.01]">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#00A8B5]/50 via-[#00A8B5] to-[#00A8B5]/50"></div>
            <h3 className="text-2xl font-semibold text-[#00A8B5] mb-8 text-center">Tarification</h3>
            <div className="space-y-8">
              {/* Prix principal */}
              <div className="bg-[#00A8B5]/10 border border-[#00A8B5]/30 rounded-xl p-6 text-center">
                <div className="mb-1">
                  <span className="block text-4xl sm:text-5xl font-extrabold text-gray-900">CHF HT 500.-</span>
                  <span className="block text-base sm:text-lg font-medium text-gray-600 mt-1">/ jour d'utilisation</span>
                </div>
                <p className="text-[#00A8B5] font-semibold text-sm mt-3">Tarif dégressif dès le 4ème jour d'utilisation</p>
              </div>

              <a
                href="#devis"
                className="block w-full bg-[#00A8B5] hover:bg-[#008f9b] text-black font-bold px-6 sm:px-8 py-3 sm:py-3.5 rounded-md transition-all duration-300 whitespace-nowrap text-center cursor-pointer text-sm sm:text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                Recevoir mon devis
              </a>

              {/* Livraison et reprise */}
              <div>
                <h4 className="text-lg font-bold text-[#00A8B5] mb-3 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-truck-line text-[#00A8B5]"></i>
                  </div>
                  Livraison et reprise
                </h4>
                <div className="pl-8 space-y-2">
                  <p className="text-2xl font-bold text-gray-900">CHF HT 300.-</p>
                  <p className="text-gray-700 text-sm">Zone Vevey + 30 km (Morges, Bulle, Saint-Maurice)</p>
                  <p className="text-gray-600 text-sm italic">Au-delà : prix sur demande</p>
                </div>
              </div>

              {/* Personnalisation */}
              <div>
                <h4 className="text-lg font-bold text-[#00A8B5] mb-3 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-palette-line text-[#00A8B5]"></i>
                  </div>
                  Personnalisation (optionnelle)
                </h4>
                <div className="pl-8 space-y-3">
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Transformez la remorque à votre image branding, covering...
                  </p>
                  <a
                    href="#personnalisation"
                    className="inline-block bg-[#00A8B5] hover:bg-[#008f9b] text-black font-semibold px-4 py-2 rounded-md transition-all duration-300 whitespace-nowrap text-center cursor-pointer text-sm hover:-translate-y-0.5"
                  >
                    Découvrir
                  </a>
                </div>
              </div>

              {/* Nettoyage */}
              <div>
                <h4 className="text-lg font-bold text-[#00A8B5] mb-3 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-brush-line text-[#00A8B5]"></i>
                  </div>
                  Nettoyage (optionnel)
                </h4>
                <div className="pl-8 space-y-2">
                  <p className="text-2xl font-bold text-gray-900">CHF HT 200.-</p>
                  <p className="text-gray-700 text-sm">À défaut de réservation, le nettoyage est à la charge du client.</p>
                  <p className="text-gray-700 text-sm">Tout nettoyage non effectué ou jugé non conforme sera facturé <span className="font-bold">CHF HT 200.-</span></p>
                </div>
              </div>

            </div>
          </div>

          {/* Services sur demande */}
          <div className="rounded-lg border-2 border-[#00A8B5]/30 relative overflow-hidden p-8 lg:p-10 bg-white/70 transition-all duration-[250ms] ease-out hover:-translate-y-1 hover:shadow-lg hover:scale-[1.01]">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#00A8B5]/50 via-[#00A8B5] to-[#00A8B5]/50"></div>
            <h3 className="text-2xl font-semibold text-[#00A8B5] mb-8 text-center">Services sur demande</h3>
            <div className="space-y-6">
              <div className="bg-[#00A8B5]/10 border border-[#00A8B5]/30 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-[#00A8B5]/20 rounded-lg mb-4 mx-auto">
                  <i className="ri-goblet-line text-[#00A8B5] text-2xl"></i>
                </div>
                <h4 className="text-lg font-semibold text-[#00A8B5] mb-3 text-center">Conception de votre offre boisson</h4>
                <p className="text-gray-700 text-center text-sm leading-relaxed">
                  Création de carte, sélection fournisseurs &amp; produits et optimisation des coûts grâce à notre réseau.
                </p>
              </div>
              <div className="bg-[#00A8B5]/10 border border-[#00A8B5]/30 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-[#00A8B5]/20 rounded-lg mb-4 mx-auto">
                  <i className="ri-service-line text-[#00A8B5] text-2xl"></i>
                </div>
                <h4 className="text-lg font-semibold text-[#00A8B5] mb-3 text-center">Exploitation complète du bar par nos équipes</h4>
                <p className="text-gray-700 text-center text-sm leading-relaxed">
                  Vous déléguez, nous gérons. Moins de contraintes, plus de résultats.
                </p>
              </div>
              <div className="bg-[#00A8B5]/10 border border-[#00A8B5]/20 rounded-lg p-4">
                <p className="text-center text-sm text-gray-700 italic">Tarifs personnalisés selon vos besoins spécifiques</p>
              </div>
              <a
                href="#devis"
                className="block w-full bg-[#00A8B5] hover:bg-[#008f9b] text-black font-bold px-6 sm:px-8 py-3 sm:py-3.5 rounded-md transition-all duration-300 whitespace-nowrap text-center cursor-pointer text-sm sm:text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                Recevoir mon devis
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
